import { usePluginTranslation } from '@translation';
import { AnomalyImportErrorCode } from '../widgets/types';

export const useGetFormattedCsvImportsErrors = () => {
  const { t } = usePluginTranslation();

  const getFormattedCsvImportsErrors = (errorCode: string) => {
    switch (errorCode) {
      case AnomalyImportErrorCode.GuidNotFound:
        return t('anomaly_plugin.info_widget.upload.excel_custom_errors.guid_not_found_text');
      case AnomalyImportErrorCode.WrongType:
        return t('anomaly_plugin.info_widget.upload.excel_custom_errors.type_is_wrong_text');
      case AnomalyImportErrorCode.WrongPriority:
        return t('anomaly_plugin.info_widget.upload.excel_custom_errors.priority_is_wrong_text');
      case AnomalyImportErrorCode.WrongStatus:
        return t('anomaly_plugin.info_widget.upload.excel_custom_errors.status_is_wrong_text');
      case AnomalyImportErrorCode.IdNotFound:
        return t('anomaly_plugin.info_widget.upload.excel_custom_errors.id_not_found_text');
      case AnomalyImportErrorCode.WrongDueDate:
        return t('anomaly_plugin.info_widget.upload.excel_custom_errors.wrong_due_date_text');
      case AnomalyImportErrorCode.WrongAssignedTo:
        return t('anomaly_plugin.info_widget.upload.excel_custom_errors.wrong_assigned_to_text');
      default:
        return;
    }
  };

  return {
    getFormattedCsvImportsErrors,
  };
};
